<template>
    <v-row wrap class="pa-1 pa-sm-0 mt-3">
        <v-col xl="5" lg="6" md="8" cols="12" class="mx-auto">
            <h2 class="text-center font-weight-light">
                HipCabin is a tastefully curated collection of the best stays &amp; cool products we’ve found for bnb travelers &amp; hosts.
            </h2>
            <h6 class="text-center overline">Everything you need to live your best nomad life</h6>
        </v-col>
        <v-col cols="12">
            <div v-for="(c,idx) in categories" :key="idx" class="py-5">
                <grid-resources
                    :hide-filter="true"
                    :heading="c.Name"
                    :view-name="c.ViewName"
                    :random="true"
                    :desc="c.Description"
                    :card-props="{ cardClass: c.CardClass, contain: c.ContainImg }"
                    :limit="6" />
                <modal-details :modal-props="{ showImage: !c.ContainImg, viewName: c.ViewName }" />
                <div class="text-center">
                    <v-btn :to="c.ViewName" color="primary" x-large rounded class="my-6">
                        More {{ c.Name }}...
                    </v-btn>
                </div>
            </div>
        </v-col>
        <v-col cols="12" sm="11" md="10" lg="9" class="mx-auto py-5">
            <Footer />
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { Footer, GridResources  } from '@/components'
import { GET_CATEGORIES } from '@/store/action-types'
import ModalDetails from '@/components/ModalDetails'

export default {
    data: () => ({
        themes: [],
    }),
    components: {
        GridResources,
        ModalDetails,
        Footer,
    },
    created () {
       this.$store.dispatch(GET_CATEGORIES)
    },
    methods: {
    },
    computed: {
        ...mapState({
            users: state => state.user.all,
            categories: state => state.category.all,
            dialogDetails: state => state.resource.dialogDetails,
        }),
        ...mapGetters([
            'isLoggedIn',
        ])
    }
}
</script>
<style scoped>
    .sticky-top {
        position: sticky;
        top: 70px;
        z-index: 3;
    }
</style>